import React, { useEffect, useState } from "react";
import {
  Box,
  CircularProgress,
  FormControl,
  IconButton,
  Typography,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import HighlightOffRoundedIcon from "@mui/icons-material/HighlightOffRounded";
import ArrowBackIosRoundedIcon from "@mui/icons-material/ArrowBackIosRounded";

import {
  getSettingState,
  setCategoryExplor,
  setSearchExplore,
} from "../../../../redux/features/settingSlice";
import CustomInput from "../../CustomInput";

const SearchField = () => {
  const dispatch = useDispatch();
  const { categoryExplor, searchExplore } = useSelector(getSettingState);
  const [search, setSearch] = useState(searchExplore);

  const handleSearch = (e) => {
    if (e.target.value !== " ") {
      setSearch(e.target.value);
    }
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      dispatch(setSearchExplore(search));
    }, 650);
    return () => {
      clearTimeout(timer);
    };
  }, [dispatch, search]);

  return (
    <Box
      sx={{
        padding: "22px 16px 12px 16px",
        backgroundColor: "white.main",
        position: "sticky",
        top: 0,
        zIndex: 3,
      }}
    >
      {categoryExplor ? (
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <Box
            onClick={() => dispatch(setCategoryExplor(null))}
            sx={{
              display: "flex",
              p: "10px",
              mr: "20px",
              ml: "10px",
              cursor: "pointer",
            }}
          >
            <ArrowBackIosRoundedIcon sx={{ fontSize: "26px" }} />
          </Box>

          <Typography
            sx={{
              fontFamily: "Tahrir",
              fontWeight: 500,
              fontSize: "32px",
              lineHeight: "32px",
              mt: "4px",
            }}
          >
            {categoryExplor.name}
          </Typography>
        </Box>
      ) : (
        <FormControl
          sx={{
            width: "100%",
          }}
          variant='outlined'
        >
          <CustomInput
            value={search}
            onChange={handleSearch}
            label='Search a table'
            startIcon={<SearchRoundedIcon />}
            endIcon={
              <>
                {search && (
                  <IconButton
                    onClick={() => setSearch("")}
                    sx={{
                      position: "absolute",
                      right: "10px",
                      bottom: "4px",
                      zIndex: 1,
                    }}
                    aria-label='clear'
                  >
                    {search === searchExplore ? (
                      <HighlightOffRoundedIcon />
                    ) : (
                      <CircularProgress size={26} />
                    )}
                  </IconButton>
                )}
              </>
            }
          />
        </FormControl>
      )}
    </Box>
  );
};

export default SearchField;
